var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inputglya"},[_c('v-textarea',{attrs:{"type":_vm.type,"label":_vm.label_show,"placeholder":_vm.label,"solo":_vm.solo,"outlined":_vm.outlined,"filled":_vm.filled,"value":_vm.value,"error-messages":_vm.nameErrors,"rows":_vm.rows,"auto-grow":_vm.auto_grow,"counter":_vm.counter},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }